import { c as _c } from "react/compiler-runtime";
import { Container, classNames, FlexColumn } from "@opensea/ui-kit";
import { TeamModuleCarousel } from "./components/TeamModuleCarousel";

// Layout component props based on module fragment result

export function TeamModuleLayout(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = classNames("flex-1 gap-10", "py-(--overview-vertical-padding)");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Container asChild={true}><FlexColumn className={t0}><TeamModuleCarousel team={props} /></FlexColumn></Container>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}